/**
 * Coup de pouce — Attendu 1060 « identifier des régularités et poursuivre une
 * suite de motifs évolutive ; trouver le nombre d'éléments pour une étape
 * donnée ». UNE page STATIQUE, partagée par les quatre generator_keys.
 * Phrases validées en texte nu par le prof le 2026-09-09, codées mot pour mot.
 *
 * L'image que l'élève a déjà : le carrelage de la fiche de 638 (5 ; 9 ; 13,
 * les rangées empilées) et la ligne de nombres avec les flèches « + 4 »
 * (Eduscol patterns p. 9, élève 1 ; trous de 638 « Rang 2 : 4 + 3 = 7 »).
 * Standard de page : le dessin (trois rangées, les 4 carreaux ajoutés en
 * orange), la ligne 5 → 9 → 13 → 17 avec « + 4 » sur chaque flèche, le
 * calcul en gros « Étape 10 : 5 + 9 × 4 = 41 » (41 en orange), puis UNE ligne
 * du geste : « De l'étape 1 à l'étape 10, il y a 9 flèches. » Elle écrit ce
 * que la figure ne montre pas (9 flèches pour 10 étapes, la figure n'en
 * montre que 3), et c'est l'erreur principale (compter 10 ajouts).
 *
 * SACRIFIÉ : le couple (f = 5, k = 4), exclu de toutes les figures et de
 * toutes les cartes du gen (cdp1060.self.test.js le vérifie sur l'image
 * rendue). Largeur bornée à 340 px, tailles de 1048.
 */

const ORANGE = '#EA580C';
const BLEU = '#2563EB';
const ENCRE = '#1E293B';

const svg = (aria, hauteur, corps) => `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 ${hauteur}" width="100%" style="max-width:340px;height:auto;display:block" role="img"
     aria-label="${aria}">
  ${corps}
</svg>`.trim();

// ─── 1. Les trois rangées : 5, puis 9, puis 13 carreaux, les ajoutés en orange ──

const C = 22;
const PAS = 24;
const X0 = 72;
const RANGEES = [5, 9, 13].map((v, i) => {
    const y = 12 + i * 32;
    const cases = Array.from({ length: v }, (_, j) => {
        const ajoute = i > 0 && j >= v - 4;
        return `<rect x="${X0 + j * PAS}" y="${y}" width="${C}" height="${C}" rx="2" fill="${ajoute ? ORANGE : BLEU}"/>`;
    }).join('');
    return `<text x="8" y="${y + 16}" font-size="13" font-weight="bold" fill="${ENCRE}">Étape ${i + 1}</text>${cases}`;
}).join('\n  ');

// ─── 2. La ligne de nombres : 5 → 9 → 13 → 17, « + 4 » sur chaque flèche ────

const Y_NOMBRES = 146;
const XS = [56, 152, 248, 344];
const fleche = (x1, x2, y) =>
    `<line x1="${x1}" y1="${y}" x2="${x2 - 8}" y2="${y}" stroke="${ORANGE}" stroke-width="2.5"/>`
    + `<polygon points="${x2 - 9},${y - 5} ${x2},${y} ${x2 - 9},${y + 5}" fill="${ORANGE}"/>`;
const NOMBRES = [5, 9, 13, 17].map((v, i) => {
    // le 17 en orange : c'est l'étape 4, celle qu'on produit, la seule qui n'est pas dessinée
    let s = `<text x="${XS[i]}" y="${Y_NOMBRES + 6}" font-size="18" font-weight="bold" text-anchor="middle" fill="${i === 3 ? ORANGE : ENCRE}">${v}</text>`;
    if (i < 3) {
        const x1 = XS[i] + 18;
        const x2 = XS[i + 1] - 20;
        s += fleche(x1, x2, Y_NOMBRES);
        s += `<text x="${(x1 + x2) / 2}" y="${Y_NOMBRES - 10}" font-size="14" font-weight="bold" text-anchor="middle" fill="${ORANGE}">+ 4</text>`;
    }
    return s;
}).join('\n  ');

const PAGE = svg(
    'Trois rangées de carreaux : étape 1, 5 carreaux ; étape 2, 9 carreaux ; étape 3, 13 carreaux ; à chaque étape les 4 carreaux ajoutés sont en orange. Dessous, 5 flèche 9 flèche 13 flèche 17, avec plus 4 sur chaque flèche, le 17 en orange. L\'étape 4 n\'est pas dessinée : 13 plus 4 égale 17.',
    210,
    `<!-- 1. les trois rangées -->
  ${RANGEES}

  <!-- 2. la ligne de nombres et les flèches + 4 : le 17 est l'étape à produire -->
  ${NOMBRES}

  <!-- 3. le geste : ce que la figure ne montre pas -->
  <text x="200" y="196" font-size="15" text-anchor="middle" fill="${ENCRE}">L'étape 4 n'est pas dessinée : 13 + 4 = <tspan font-weight="bold" fill="${ORANGE}">17</tspan>.</text>`,
);

const AIDE = { pages: [{ titre: 'L\'étape suivante', svg: PAGE }] };

const CP_1060 = {
    suivante_qcm_unique: AIDE,
    suivante_tableau_vf: AIDE,
};

export default CP_1060;
